import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "components/ui/Button";

export default function QuickActions() {
  const navigate = useNavigate();
  const actions = [
    { label: "Nueva Calculadora", icon: "Calculator", route: "/batch-calculator", variant: "default" },
    { label: "Gestión de Lotes", icon: "Layers", route: "/active-batch-management", variant: "outline" },
  ];
  return (
    <div className="flex flex-wrap gap-3">
      {actions?.map((a) => (
        <Button
          key={a?.route}
          variant={a?.variant}
          iconName={a?.icon}
          iconPosition="left"
          onClick={() => navigate(a?.route)}
        >
          {a?.label}
        </Button>
      ))}
    </div>
  );
}